export const languages = [
  { name: 'Français', code: 'fr' },
  { name: 'English', code: 'en' },
  { name: 'Deutsch', code: 'de' },
  { name: '日本語', code: 'jp' },
];
